import { useEffect } from 'react'
import { useHistory } from '@fs/zion-router'
import { buildOwnAnswerRealignUrl } from '../helpers/activityGroupUrl'

/**
 * Keeps the URL in agreement with the UI when a user starts their own activity from another person's
 * answer (DSC-9347). Once the signed-in user's own answer exists, this realigns the route to it via
 * history.replace, so a refresh/back/share stays in the user's own session instead of bumping back to
 * the other person's results. The realignment decision lives in buildOwnAnswerRealignUrl.
 */
export default function useActivityGroupUrlRealign({
  isOpen,
  mode,
  topicId,
  activityGroupId,
  subActivityGroupId,
  ownAnswerId,
  routeAnswerId,
  activeCisId,
  pathname,
}) {
  const history = useHistory()

  useEffect(() => {
    const realignUrl = buildOwnAnswerRealignUrl({
      isOpen,
      mode,
      topicId,
      activityGroupId,
      subActivityGroupId,
      ownAnswerId,
      routeAnswerId,
      activeCisId,
    })
    if (realignUrl && realignUrl !== pathname) {
      history.replace(realignUrl)
    }
  }, [
    isOpen,
    mode,
    topicId,
    activityGroupId,
    subActivityGroupId,
    ownAnswerId,
    routeAnswerId,
    activeCisId,
    pathname,
    history,
  ])
}
